import * as React from "react";

function SvgAzure(props, ref) {
  return (
    <svg
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      fill="#035bda"
      fillRule="evenodd"
      {...{ ...props, ref }}
    >
      <path d="M19.867 7.282l-4.733 9.533 8.333 9.66L8 28.23l24 .25zm-.934-3.762L8.067 12.613 0 26.223l6.867-.7z" />
    </svg>
  );
}

export default React.forwardRef(SvgAzure);
